import { useState } from "react";
import { useEffect } from "react";
import useLocalStorage from "react-use-localstorage";
import useAPIs from "./useAPIs";

const useMasters = () => {
  const [ranks, setRanks] = useLocalStorage("ranks", null);
  const [ranksList, setRanksList] = useState(null);
  const [mastersError, setError] = useState(null);
  const { apiError, postData, getData } = useAPIs();

  useEffect(() => {
    setError(apiError);
  }, [apiError]);

  const [distributor, setDistributor] = useLocalStorage("distributor", null);
  const [loggedInUser, setLoggedInUser] = useState(null);

  useEffect(() => {
    if (distributor && distributor !== "") {
      const distributorFromLocalStorage = JSON.parse(distributor);
      setLoggedInUser(distributorFromLocalStorage);
    }

    if (ranks && ranks !== "") {
      const ranksFromLocalStorage = JSON.parse(ranks);
      const hasHierarchyIds = Array.isArray(ranksFromLocalStorage)
        ? ranksFromLocalStorage.some((rank) => rank?.hierarchy_id != null)
        : false;

      if (hasHierarchyIds) {
        setRanksList(ranksFromLocalStorage);
      } else {
        getData("/enrollment/fetch-rank-list", (ranksData) => {
          setRanksList(ranksData);
          setRanks(JSON.stringify(ranksData));
        });
      }
    } else {
      getData("/enrollment/fetch-rank-list", (ranksData) => {
        setRanksList(ranksData);
        setRanks(JSON.stringify(ranksData));
      });
    }
  }, []);

  const updateDistributor = (distributorDetails) => {
    if (distributorDetails) {
      setDistributor(JSON.stringify(distributorDetails));
      setLoggedInUser(distributorDetails);
    }
  };

  const enrichNotification = (notification) => {
    if (typeof notification?.data !== "string" || notification.data.trim() === "") {
      return { ...notification, parsed_data: null };
    }
    try {
      return { ...notification, parsed_data: JSON.parse(notification.data) };
    } catch {
      return { ...notification, parsed_data: null };
    }
  };

  const normalizeNotificationsResponse = (payload, data) => {
    const notReadCount = Number(data?.total_count?.[0]?.not_read_count ?? 0) || 0;

    // Oldest: { report, page_no, total_no_of_pages }
    if (Array.isArray(data?.report)) {
      return {
        ...data,
        report: data.report.map(enrichNotification),
        not_read_count: data?.not_read_count ?? notReadCount,
        total_count: data?.total_count ?? [],
      };
    }

    const notificationList = data?.notification_list;

    // Latest: notification_list is { report, page_no, total_no_of_pages }
    if (
      notificationList &&
      typeof notificationList === "object" &&
      !Array.isArray(notificationList) &&
      Array.isArray(notificationList.report)
    ) {
      return {
        report: notificationList.report.map(enrichNotification),
        page_no: notificationList.page_no ?? payload?.page_no ?? 1,
        total_no_of_pages: notificationList.total_no_of_pages ?? 0,
        total_count: data?.total_count ?? [],
        not_read_count: notReadCount,
      };
    }

    // Intermediate: notification_list was a flat array
    const report = Array.isArray(notificationList) ? notificationList : [];

    return {
      report: report.map(enrichNotification),
      page_no: data?.page_no ?? payload?.page_no ?? 1,
      total_no_of_pages: data?.total_no_of_pages ?? 0,
      total_count: data?.total_count ?? [],
      not_read_count: notReadCount,
    };
  };

  const getNotifications = (payload, onSuccess, onError) => {
    payload.distributor_id = loggedInUser?.distributor_id;
    postData(
      "/notif/fetch-dist-notification",
      payload,
      (data) => {
        onSuccess && onSuccess(normalizeNotificationsResponse(payload, data));
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const updateNotificationStatus = (payload, onSuccess, onError) => {
    payload.distributor_id = loggedInUser?.distributor_id;
    payload.platform_id = 1;
    postData(
      "/notif/update_message_status",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  return {
    ranksList,
    mastersError,
    loggedInUser,
    updateDistributor,
    getNotifications,
    updateNotificationStatus,
  };
};

export default useMasters;
